import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  BookOpen,
  Coffee,
  Kanban as KanbanIcon,
  LayoutDashboard,
  ListChecks,
  Menu,
  Plus,
  Users,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { LeadDrawerProvider } from "@/lib/leadDrawer";
import { LeadDrawer } from "@/components/leads/LeadDrawer";
import { NovoLeadModal } from "@/components/leads/NovoLeadModal";

const LINKS = [
  { to: "/", label: "Fila de hoje", end: true, icon: ListChecks },
  { to: "/kanban", label: "Kanban", end: false, icon: KanbanIcon },
  { to: "/leads", label: "Leads", end: false, icon: Users },
  { to: "/scripts", label: "Scripts", end: false, icon: BookOpen },
  { to: "/dashboard", label: "Dashboard", end: false, icon: LayoutDashboard },
];

export function AppShell() {
  const { appUser, signOut } = useAuth();
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [novoLeadAberto, setNovoLeadAberto] = useState(false);

  return (
    <LeadDrawerProvider>
      <a href="#conteudo-principal" className="skip-link">
        Pular para o conteúdo
      </a>
      <div className="app-shell">
        {/* Backdrop fecha no clique apenas como atalho de mouse: o
            equivalente por teclado e o proprio botao de menu (aria-expanded)
            na topbar, ja focavel e operavel por Enter/Espaco. */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div
          className={`sidebar-backdrop${sidebarAberta ? " is-open" : ""}`}
          onClick={() => setSidebarAberta(false)}
        />
        <nav
          className={`sidebar${sidebarAberta ? " is-open" : ""}`}
          aria-label="Navegação principal"
        >
          <div className="sidebar__brand">
            <Coffee className="icon" size={20} aria-hidden="true" />
            CRM Café Labs
          </div>
          <div className="sidebar__nav">
            {LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className="sidebar__link"
                onClick={() => setSidebarAberta(false)}
              >
                <link.icon className="icon" size={18} aria-hidden="true" />
                {link.label}
              </NavLink>
            ))}
          </div>
          <div className="sidebar__footer">
            <div className="sidebar__user">{appUser?.nome}</div>
            <button type="button" className="btn btn--ghost btn--sm" onClick={() => void signOut()}>
              Sair
            </button>
          </div>
        </nav>

        <div className="app-main">
          <header className="topbar">
            <button
              type="button"
              className="btn btn--ghost btn--icon mobile-nav-toggle"
              aria-label="Abrir menu de navegação"
              aria-expanded={sidebarAberta}
              onClick={() => setSidebarAberta((v) => !v)}
            >
              <Menu className="icon" size={20} aria-hidden="true" />
            </button>
            <div className="spacer" />
            <button type="button" className="btn btn--primary" onClick={() => setNovoLeadAberto(true)}>
              <Plus className="icon" size={16} aria-hidden="true" />
              Novo lead
            </button>
          </header>

          <main id="conteudo-principal" className="page-content">
            <Outlet />
          </main>
        </div>
      </div>

      <LeadDrawer />
      {novoLeadAberto && <NovoLeadModal onClose={() => setNovoLeadAberto(false)} />}
    </LeadDrawerProvider>
  );
}
